<template>
  <div>
    <v-card
      v-for="(item, indi) in items"
      :key="indi + Math.random()"
      class="mb-4"
      min-width="350px"
    >
      <v-row class="mb-n12">
        <v-col :cols="12">
          <span :style="{ color: 'teal', fontSize: '20px' }"
            >{{ item.name }}
            <v-icon color="red" @click="$emit('remove-item', [items, indi])"
              >mdi-delete</v-icon
            >
            <br />
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="isMobile ? 3 : 2"><span>Qty</span></v-col>
        <v-col :cols="isMobile ? 4 : 4"><span>Price</span></v-col>
        <v-col :cols="isMobile ? 4 : 4"><span>LineTotal</span></v-col>
      </v-row>

      <v-row>
        <v-col :cols="isMobile ? 3 : 2" class="mx-1">
          <input
            :min="1"
            :id="'quantity-' + indi"
            :size="isMobile ? 2 : 2"
            :style="{
              border: 'none',
              borderBottom: '1px black solid',
              'margin-top': '4px',
            }"
            @blur="changeQuantity(indi, item)"
            :value="item.quantity"
          />
        </v-col>

        <v-col :cols="isMobile ? 4 : 4" class="mx-1">
          <span>{{ getCurrency }}</span>
          <input
            :id="'cost-' + indi"
            :size="isMobile ? 4 : 4"
            :style="{
              border: 'none',
              borderBottom: '1px black solid',
              'margin-top': '4px',
            }"
            @blur="changeCost(indi, item)"
            :value="item.price"
          />
        </v-col>

        <v-col :cols="isMobile ? 4 : 4" class="mt-2">
          <span>{{ getCurrency + formatMoney(item.lineTotal) }}</span>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
export default {
  props: ["items"],

  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
  },

  methods: {
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },
    changeCost(indi, item) {
      item.price = helpersJs.stripNonDigitsAndCommasFromMoney(
        event.target.value
      );
      this.$emit("update-line-total", item);
    },
    stripNonDigitsAndCommasFromMoney(amount) {
      return helpersJs.stripNonDigitsAndCommasFromMoney(amount);
    },

    changeQuantity(indi, item) {
      // if (
      //   (item["item_type"] =
      //     "product" &&
      //     item.inventory.quantity_in_stock < Number(event.target.value))
      // ) {
      //   alert(
      //     "Cannot Exceed Available Stock! " + item.inventory.quantity_in_stock
      //   );
      //   return;
      // }

      item.quantity = helpersJs.stripNonDigitsAndCommasFromMoney(
        event.target.value
      );
      this.items.sort();
      this.$emit("update-line-total", item);
    },
  },
};
</script>

<style></style>
